import React, { useEffect, useState } from 'react'
import "./Style.css"

//getting the local storage data back

const getData=()=>{
    const list=localStorage.getItem('my-todo-list');
    //we need to pass the key of which the value we want from the local storage

    if(list){
        return JSON.parse(list);
    }else{
        return [];
    }
}
export default function Todo() {
    const [inputData, setInputData]=useState("");
    const [items, setItems] =useState(getData);
    const [isedititem,setIsEditItem]= useState("");
    const [tooglebutton,setToggleButton]=useState(false);

    const addItem=() =>{
        if(!inputData){
            alert("Please enter a valid todo");
        }else if(inputData && tooglebutton){
            setItems(
                items.map((currelem)=>{
                    if(currelem.id === isedititem){
                        // if that element id is found which is to be edited
                        return {...currelem, name:inputData};
                    }
                    return currelem;
                })
            )
            setInputData("");
            setIsEditItem(null);
            setToggleButton(false);
        }
        
        
        else{
            const newInputData={
                id:new Date().getTime().toString(),//to get the unique id we will have the time it is added as the unique id
                name:inputData,
            };

            //now we have stored it and now we will pass it on to the use state function to render it
            setItems([...items,newInputData]);
            setInputData("");
        }
    };

//configuring the edit button
    const editItem=(index)=>{
        const item_tobe_edited=items.find((element)=>{
            return element.id===index;
        })
        setInputData(item_tobe_edited.name);
        setIsEditItem(index);
        setToggleButton(true);
    }

    const deleteItem =(index)=>{
        const updatedItems=items.filter((curelem)=>{
            return curelem.id !== index;
        });
        setItems(updatedItems);//calling the setItems function to render it
    }

    //configuring the removing all button
    const removeAll =()=>{
        setItems([]);
    }

    //now setting up the local storage
    useEffect(()=>{
        localStorage.setItem('my-todo-list',JSON.stringify(items));
        //this tores the values in key and value pairs so the key is my-todo-list and all the item elements wil be its values
        //the values need to be stored int he strimg as well so we use the stringify function to convert it into string
    },[items])


  return (
    <>
      <div className="main-div">
            <div className="child-div">
                <figure>
                    <img src="./images/todo.jpg" alt="todologo" />
                    <figcaption>Add your todos here📋</figcaption>
                </figure>
                <div className="addItems">
                    <input type="text" placeholder='📝Enter Your todo' className='form-control' 
                    value={inputData } 
                    onChange={(event)=>{setInputData(event.target.value)}}
                    />
                    {
                        tooglebutton ? <i className='far fa-edit add-btn'onClick={addItem}></i> : 
                        <i className='fa fa-plus add-btn'onClick={addItem}></i>
                    }
                   
                </div>
              
                <div className="showItems">
                    {items.map((element)=>{
                        //here each element will a pair of id and name passed from newInputData
                        return(
                        <div className="eachItem" key={element.id}>
                            <h3>{element.name}</h3>
                            <div className="todo-btn">
                            <i className='far fa-edit add-btn' onClick={()=>{ editItem(element.id)}}></i>
                            <i className='far fa-trash-alt add-btn' onClick={()=> deleteItem(element.id)}></i>
                        </div>
                    </div> 
                        )
                    })
                    }


                </div>

                <div className="showItems">
                    <button className='btn effect04' data-sm-link-text="Remove All" onClick={removeAll}>
                        <span>CHECK LIST</span>
                    </button>
                </div>
            </div> 
      </div>
    </>
  )
}
